<template>
	<div>
		<topback title="Auth UPI" path="back"></topback>
		<div class="usdt-header">
			<md-notice-bar
				icon="coupon"
				type="activity"
				>
				{{ usdt_inrtext }}
			</md-notice-bar>
			<div class="usdt-amount">
                <span>₹</span>
				<md-amount value="1" has-separator></md-amount>
			</div>
			<vue-qr :text="payupiid" :size="160" :margin="0" ref="qrcode"></vue-qr>
			<span>Please use other payment tools to scan the code or copy upi to pay 1 rupee to complete the authentication</span>
		</div>

		<div class="usdt-info">
			<md-cell-item title="UPI ID" :brief="upiid">
				<img src="/static/icon/copy.png" class="copy cell-img" :data-clipboard-text="upiid" slot="right"
					@click="onCopyupiid" />
			</md-cell-item>
		</div>
        <md-field>
            <md-input-item
                ref="input_utr"
                title="UTR"
                placeholder="utr"
                v-model="utr"
                is-amount
                :maxlength="12"
            ></md-input-item>
        </md-field>

		<div class="usdt-btn">
			<md-button type="default" inline @click="downloadImage">Save Image</md-button>
			<md-button type="primary" inline @click="auth_upi">Auth</md-button>
		</div>
	</div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import { toClipboard } from '@soerenmartius/vue3-clipboard'
import VueQr from 'vue-qr'
import { getcollectiontool, authupi } from '@/request/api'


export default {
	name: 'authupi',
	components: {
		[topback.name]: topback,
		[iconimg.name]: iconimg,
		VueQr
	},

	data() {
		return {
			upiid: "",
			usdt_inrtext: "Scan code payment to complete link kyc auth",
            ct: {},
            ctid: "",
			queryinterval: "",
			times: 0
		}
	},
	created() {
        this.ctid = this.$route.params.ctid;
        this.get_getcollectiontool();
	},

	methods: {
        get_getcollectiontool() {
            getcollectiontool({id: this.ctid}).then(res=>{
                if(res.code === 200) {
                    this.ct = res.data;
                    this.upiid = res.data.upi;
					this.payupiid = "upi://pay?pa=" + this.upiid + "&pn=Ta&am=1.00&cu=INR";
                } else {
                    this.$toast.failed(res.errmsg);
                }
            });
        },
		downloadImage() {
			const iconUrl = this.$refs.qrcode.$el.src;
			const a = document.createElement('a');
			const event = new MouseEvent('click');
			a.download = "itoken.png";
			a.href = iconUrl;
			a.dispatchEvent(event);
		},
        onCopyupiid() {
            toClipboard(this.upiid);
            this.$toast.succeed('copy successfully',1000);
        },
        auth_upi() {
            this.$toast.loading('auth...');
            if(this.utr.length !== 12) {
                this.$toast.failed("utr error");
                return;
            }
			authupi({
                ctid: this.ctid,
                utr: this.utr
            }).then(res=>{
                this.$toast.hide();
                if(res.code === 200) {
                    let that = this;
                    this.$toast.succeed("auth success");
					clearInterval(this.queryinterval);
                    setTimeout(() => {
                        that.$router.back();
                    }, 1200);
                }
            });
			let that = this;
			this.queryinterval = setInterval(() => {
				if(this.times > 40) {
					clearInterval(that.queryinterval);
					this.times++;
				} else {
					that.auth_upi();
				}
			}, 3000);
        }
	}
}

</script>
<style scoped>
.usdt-header {
	margin-top: 0.99rem;
	text-align: center;
	border-bottom-width: 2px;
	border-bottom-style: groove;
	border-bottom-color: rgb(192, 192, 192);
	padding-bottom: 0.5rem;
}

.usdt-header span {
	display: block;
	font-size: 0.1rem;
}

.usdt-info .cell-img {
	width: 0.5rem;
}

.usdt-info>>>.md-cell-item-title {
	color: #858b9c;
	font-size: 0.21rem;
}

.usdt-info>>>.md-cell-item-brief {
	color: black;
	font-size: 0.26rem;
	line-height: 1.4;
	margin-top: 0.08rem;
	width: 6rem;
	word-wrap: break-word;
}

.usdt-btn {
	position: fixed;
	left: 0;
	right: 0;
	margin: 0 auto;
	bottom: 15px;
	text-align: center;
	width: 100%;
}

.rechargelog-img {
	width: 0.4rem;
}

.usdt-amount {
	display: flex;
	justify-content: center;
	margin-bottom: 0.3rem;
	margin-top: 0.3rem;
}

.usdt-amount span {
	font-size: 0.45rem;
	margin-left: 0.2rem;
}</style>



// WEBPACK FOOTER //
// src/views/my/authupi.vue